import React from 'react';
import PropTypes from 'prop-types';
import { Tabs, Tab, Box, Typography } from "@material-ui/core";
import TaskAutomationLead from "./TaskAutomationLead";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <Typography
            component="div"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            <Box p={0}>{children}</Box>
        </Typography>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`,
    };
}


export default function TaskAutomationTab(data) {
    const [value, setValue] = React.useState(0);

    const automationData = data.automationData || [];
    const onDelete = data.onDelete;

    // entity ke basis pe filter karo
    const leadList       = automationData.filter(item => item.entity === 1);
    const contactList    = automationData.filter(item => item.entity === 2);
    const companyList    = automationData.filter(item => item.entity === 3);
    const opportunityList= automationData.filter(item => item.entity === 4);
    const projectList    = automationData.filter(item => item.entity === 5);

    function handleChange(event, newValue) {
        setValue(newValue);
    }
    
    return (
        <React.Fragment>
            <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="primary"
                variant="scrollable"
                scrollButtons="auto"
                className="settings_tabs"
                aria-label="scrollable auto tabs"
            >
                <Tab label={`Leads (${leadList.length})`} {...a11yProps(0)} />
                <Tab label={`Contacts (${contactList.length})`} {...a11yProps(1)} />
                <Tab label={`Company (${companyList.length})`} {...a11yProps(2)} />
                <Tab label={`Opportunity (${opportunityList.length})`} {...a11yProps(3)} />
                <Tab label={`Projects (${projectList.length})`} {...a11yProps(4)} />
            </Tabs>
            <div className="v_scroll position-relative task_automation pt-16 pb-16">
                <TabPanel value={value} index={0} className="h-100">
                    <TaskAutomationLead automationList={leadList} entityType="lead" onDelete={onDelete} />
                </TabPanel>
                <TabPanel value={value} index={1} className="h-100">
                    <TaskAutomationLead automationList={contactList} entityType="contact" onDelete={onDelete} />
                </TabPanel>
                <TabPanel value={value} index={2} className="h-100">
                    <TaskAutomationLead automationList={companyList} entityType="company" onDelete={onDelete} />
                </TabPanel>
                <TabPanel value={value} index={3} className="h-100">
                    <TaskAutomationLead automationList={opportunityList} entityType="opportunity" onDelete={onDelete} />
                </TabPanel>
                <TabPanel value={value} index={4} className="h-100">
                    <TaskAutomationLead automationList={projectList} entityType="project" onDelete={onDelete} />
                </TabPanel>
            </div>
        </React.Fragment>
    );
}